    <p-dialog [(visible)]="showDialog" 
        header="{{header}}" 
        styleClass="quick-view-grid-row venue-rates-dialog" 
        icon="pi pi-exclamation-triangle"
        [style]="{width: '50%', minWidth: '550px'}"
        appendTo="body" 
        showEffect="fade" 
        [modal]="true" 
        (onHide)="onClose()">

            @if(isVenueRatesLoadingResults){
                <div class="example-loading-shade">
                    <mat-spinner></mat-spinner>
                </div>
            }
        
        <form [formGroup]="venueForm" (ngSubmit)="onSave()">
            <div class="form-panel">
                <div class="row">
                @for (col of columns; track col.mappingkey){
                    @if(col.isFormField == 'true'){
                        @if(col?.datatype === 'Text'){
                            <div class="col-12">
                                <div class="row mb-1 field-wrapper">
                                    <div class="col-12">
                                        <label [for]="col.mappingkey">
                                            {{col.ui_columnname}}
                                            @if(col?.isrequired === 'true'){
                                                <span class="required-asterisk">*</span>
                                            }
                                        </label>
                                    </div>
                                    <div class="col-12">
                                        <div class="form-field-wrapper textarea-wrapper">
                                            <textarea pInputText
                                                [ngClass]="{'input-error': isFieldInvalid(col.mappingkey)}"
                                                [ngStyle]="{width:'100%', height:'150px'}"
                                                [id]="col.mappingkey"
                                                [formControlName]="col.mappingkey">
                                            </textarea>
                                            @if(getErrorMessage(col)){
                                                <small class="error-message text-error-message">
                                                    {{ getErrorMessage(col) }}
                                                </small>
                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>
                        } @else {
                            <div class="col-12 col-lg-6">
                                <div class="row mb-1 field-wrapper">
                                    <div class="col-12 col-md-4">
                                        <label [for]="col.mappingkey">
                                            {{col.ui_columnname}}
                                            @if(col?.isrequired === 'true'){
                                                <span class="required-asterisk">*</span>
                                            }
                                        </label>
                                    </div>
                                    <div class="col-12 col-md-8">
                                        <div class="form-field-wrapper">

                                            @if(col?.datatype !== 'Date'){
                                                <input
                                                    pInputText
                                                    [maxlength]="col?.maxlength"
                                                    style="width:100%"
                                                    [placeholder]="col?.disabled ? '' : 'Enter value'"
                                                    [id]="col.mappingkey"
                                                    [formControlName]="col.mappingkey"
                                                    [ngClass]="{'input-error': isFieldInvalid(col.mappingkey)}"
                                                />
                                            }

                                            @if(col?.datatype === 'Date'){
                                                <p-datepicker
                                                    #dp
                                                    [inputId]="col.mappingkey"
                                                    [formControlName]="col.mappingkey"
                                                    [showIcon]="true"
                                                    [showOnFocus]="false"
                                                    iconDisplay="input"
                                                    [touchUI]="true"
                                                    appendTo="body"
                                                    dateFormat="yy-mm-dd"
                                                    placeholder="YYYY-MM-DD or YYYYMMDD"
                                                    [readonlyInput]="false"
                                                    (onInput)="onDateInput($event, col.mappingkey)"
                                                    [keepInvalid]="true"
                                                    styleClass="calendar-form-field"
                                                    [ngClass]="{'date-picker-input-error': isFieldInvalid(col.mappingkey)}"
                                                    [motionOptions]="{ duration: 0 }">
                                                </p-datepicker>
                                            }

                                            @if(getErrorMessage(col)){
                                                <small class="error-message">
                                                    {{ getErrorMessage(col) }}
                                                </small>
                                            }

                                        </div>
                                    </div>
                                </div>
                            </div>
                        }
                    }
                }
                </div>
            </div>
            
            @if(mode !== 'view'){
                <div class="col-lg-12 btn-panel">
                        <div class="text-end">
                            
                            <p-button type="button" icon="fa fa-close" id="close" 
                                class="venue-rates-footer-button"
                                (click) = "onClose()"
                                label="Close">
                            </p-button>

                            <p-button type="submit" icon="fa fa-check" id="save" 
                                class="venue-rates-footer-button" 
                                label="Save"
                                [disabled]="venueRatesService.isLoadingResults">
                                    @if(venueRatesService.isLoadingResults){
                                        <i class="pi pi-spin pi-spinner"></i>
                                    }
                            </p-button>
                        </div>
                </div>
            }
        </form>
    </p-dialog>